import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import CustomDropDown from "../CustomDropDown/CustomDropDown";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import classes from './InviteUserForm.module.css';
import ToggleInput from "../UI/ToggleInput";
import Input from "../CustomDropDown/Input/Input";
import Button1 from "../UI/Button/Button1";
import { inviteUser, UserPowerSearch } from "../../Api Methods/Api";
import { ListBox } from "primereact/listbox";
import { Button } from "primereact/button";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const emailReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: emailRegex.test(action.val) };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

// Reducer function
const userRoleReducer = (state, action) => {

    if (action.type === 'TOGGLE_DROPDOWN') {
        return { ...state, showDropDownOptions: !state.showDropDownOptions, isValid: null };
    }

    if (action.type === 'SELECT_OPTION') {
        return { ...state, selectedOption: action.payload, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'BLUR_DROPDOWN') {
        return { ...state, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { selectedOption: null, isValid: null };
    }
    //otherwise 
    return { state };
};


const InviteAdminForm = ({ apiData, DeviceId, userID, userRole, userEmail, DeviceName, label, HandleCloseModal, HandleDeviceUserList, companyName, setUserAdded, setFailedToAdd, setFailMessage}, props) => {

    const [emailState, dispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });

    // UserRole Drop Down reducer  ----------------
    const [userRoleState, dispatchUserRole] = useReducer(userRoleReducer, {
        showDropDownOptions: false,
        selectedOption: '', // Initial selectedOption state
        isValid: null
    });

    const { showDropDownOptions: showUserRoleDropDownOptions, selectedOption: selectedUserRoleOption } = userRoleState;

    const emailInputRef = useRef();
    const userRoleDropdownRef = useRef();

    const [userSuggestions, setUserSuggestions] = useState([]);
    const [stopSearch, setStopSearch] = useState(false)
    const [emailSelected, setEmailSelected] = useState(false)


    useEffect(() => {
        setStopSearch(false)
        const searchUser = async () => {
            const users = await UserPowerSearch(apiData, emailState.value, dispatch)
            console.log(users)
            const userEmailAddresses = users[0].users
                .filter(user => user.portalAccess !== null)
                .map(user => user.email);
            setUserSuggestions(userEmailAddresses)
        }

        const delayDebounceFn = setTimeout(() => {
            if (emailState.value !== '' && !stopSearch){
                searchUser()
            } else {
                setUserSuggestions([])
            } 
        }, 500);
        return () => clearTimeout(delayDebounceFn);

    }, [emailState.value])

    const emailChangeHandler = (event) => {
        setEmailSelected(false);   
        dispatchEmail({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }
    
    const validateEmailHandler = () => {
        dispatchEmail({ type: 'INPUT_BLUR' });
    }

    // Drop down handlers ---------------
    const handleUserRoleDropDownOnClick = () => {
        dispatchUserRole({ type: 'TOGGLE_DROPDOWN' });
    };

    const handleUserRoleOptionChange = (option) => {
        dispatchUserRole({ type: 'SELECT_OPTION', payload: option });
    };
    const handleUserRoleBlur = () => {
        dispatchUserRole({ type: 'BLUR_DROPDOWN' });
    };

    const onClearHandler = () => {
        dispatchEmail({ type: 'INPUT_CLEAR', val: "" })
        dispatchUserRole({ type: 'INPUT_CLEAR', val: "" })
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const inviteAdmin = async () => {
        const email = emailState.value;
        userRole = "Manager"
            
        inviteUser(apiData, DeviceId, userID, userRole, email, DeviceName, companyName, dispatch, 0, 0).then((responseData) => {

            if (responseData.success){
                HandleCloseModal();
                HandleDeviceUserList();
                setUserAdded(true)
            } else {
                setFailMessage(responseData.msg)
                setFailedToAdd(true)
            }
        })        
    };

    const setSelectedEmail = (e) => {
        setEmailSelected(true);
        setStopSearch(true);
    
        dispatchEmail({ type: 'USER_INPUT', val: e.value }); // update email manually
    
        setUserSuggestions([]);
    };
    
    return (
        <form autoComplete="off" className={classes["container"]} method="dialog" >
            <p style={{fontWeight:"500", fontSize:"16px", color:"#6e6e6e"}}>Search for an admin by name or email</p>
            <p style={{fontWeight:"500", fontSize:"14px", color:"#999797", margin:"0px"}}>As you type, matching admins will be suggested automatically.</p>
            <p style={{fontWeight:"500", fontSize:"14px", color:"#999797", margin:"0px"}}>Please note, as this site is schedule only, only admins can be added</p>
            <p style={{fontWeight:"500", fontSize:"15px", color:"#6e6e6e", margin:"0px", marginTop:"5px"}}>You must select an email address from the suggested list,</p>

            <ul className={classes["inputs-list"]}>
                <li className={classes["input-container"]}>
                    <input
                        type="text"
                        name="fake-email"
                        autoComplete="email"
                        style={{ display: 'none' }}
                    />

                    <Input
                        className={classes.input}
                        placeholder={"Search for admins email address"}
                        ref={emailInputRef}
                        id="Email"
                        type={"text"}
                        isValid={emailState.isValid}
                        value={emailState.value}
                        onChange={emailChangeHandler}
                        onBlur={validateEmailHandler}
                        name="email-no-autofill-123"
                        autoComplete="new-password"
                        readOnly
                        onFocus={(e) => e.target.removeAttribute('readonly')}
                    />

                    {userSuggestions.length > 0 && (
                        <div>
                            <ListBox 
                                value={emailState.value}
                                onChange={setSelectedEmail}
                                options={userSuggestions}
                                className="w-full md:w-14rem"
                            />
                        </div>   
                    )}
                </li>

                <div className={classes["button-container"]}>
                    <Button label="Add admin" severity="success" onClick={inviteAdmin} disabled={emailSelected == false}icon="pi pi-user-plus" />
                </div>
            </ul>
        </form>
    )
}

export default InviteAdminForm;

